/* ==========================================================================
   Represent Theme - Global JavaScript
   ========================================================================== */

(function () {
  'use strict';

  /* ----- Helpers ----- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // Shopify formatMoney - uses global theme money format if available
  var THEME_MONEY_FORMAT = window.themeMoneyFormat || '${{amount}}';
  function formatMoney(cents) {
    var value = parseFloat(cents / 100).toFixed(2);
    if (THEME_MONEY_FORMAT.indexOf('{{amount}}') !== -1) {
      return THEME_MONEY_FORMAT.replace('{{amount}}', value);
    }
    return THEME_MONEY_FORMAT.replace('{{amount}}', value);
  }

  // Global test function for cart debugging
  window.testCart = function(variantId, quantity) {
    console.log('Testing cart update with:', { variantId: variantId, quantity: quantity });
    var params = new URLSearchParams();
    params.append('id', variantId);
    params.append('quantity', quantity);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString()
    }).then(function(r) { return r.json(); }).then(console.log);
  };

  /* ----- Sticky header shadow ----- */
  function initStickyHeader() {
    var header = $('.site-header--sticky');
    if (!header) return;
    var threshold = 8;
    var update = function () {
      if (window.scrollY > threshold) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ----- Mobile menu ----- */
  function initMobileMenu() {
    var toggle = $('[data-mobile-menu-toggle]');
    var close = $('[data-mobile-menu-close]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;

    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function hide() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function (e) {
      if (window.innerWidth > 1024) {
        // Desktop: let initMegaMenu handle it; do NOT open mobile drawer
        e.stopPropagation();
        return;
      }
      open();
    });
    if (close) close.addEventListener('click', hide);
    menu.addEventListener('click', function (e) {
      if (e.target === menu) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) hide();
    });
  }

  /* ----- Hero carousel ----- */
  function initHero() {
    $$('.hero').forEach(function (hero) {
      var track = $('[data-hero-track]', hero);
      if (!track) return;

      var slides = $$('[data-hero-slide]', track);
      var dots = $$('[data-hero-dot]', hero);
      var prev = $('[data-hero-prev]', hero);
      var next = $('[data-hero-next]', hero);
      if (slides.length < 2) return;

      var autoplay = hero.dataset.autoplay === 'true';
      var interval = parseInt(hero.dataset.interval, 10) || 6000;
      var index = 0;
      var timer = null;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.toggle('hero__slide--active', idx === index);
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('hero__dot--active', idx === index);
        });
      }

      function start() {
        stop();
        if (!autoplay) return;
        timer = setInterval(function () { goTo((index + 1) % slides.length); }, interval);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (prev) prev.addEventListener('click', function () { goTo((index - 1 + slides.length) % slides.length); start(); });
      if (next) next.addEventListener('click', function () { goTo((index + 1) % slides.length); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          goTo(parseInt(d.dataset.index, 10));
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      // Touch swipe
      var touchStartX = 0;
      var touchEndX = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 50) {
          goTo(diff < 0 ? index + 1 : index - 1);
          start();
        }
      }, { passive: true });

      start();
    });
  }

  /* ----- Countdown timer ----- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var endRaw = el.dataset.end;
      var end = new Date(endRaw);
      if (isNaN(end.getTime())) return;

      var days = $('[data-days]', el);
      var hours = $('[data-hours]', el);
      var minutes = $('[data-minutes]', el);
      var seconds = $('[data-seconds]', el);
      var prefixEl = $('.countdown__prefix', el);
      var ctaEl = $('.countdown__cta', el);

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function update() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          if (days) days.textContent = '00';
          if (hours) hours.textContent = '00';
          if (minutes) minutes.textContent = '00';
          if (seconds) seconds.textContent = '00';
          if (prefixEl) prefixEl.textContent = 'Sale ended';
          if (ctaEl) ctaEl.style.display = 'none';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (days) days.textContent = pad(d);
        if (hours) hours.textContent = pad(h);
        if (minutes) minutes.textContent = pad(m);
        if (seconds) seconds.textContent = pad(s);
      }

      update();
      setInterval(update, 1000);
    });
  }

  /* ----- Mega menu: triggered by hamburger button ----- */
  function initMegaMenu() {
    var trigger = $('[data-mega-menu-trigger]');
    var panel = $('[data-mega-menu-panel]');
    var header = $('.site-header');
    var mobileDrawer = $('[data-mobile-menu]');
    if (!trigger || !header) return;

    function openPanel() {
      if (panel) panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closePanel() {
      if (panel) panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    // Click trigger
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.innerWidth <= 1024) {
        // Mobile: open drawer
        if (mobileDrawer) {
          mobileDrawer.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        // Desktop: toggle mega menu panel
        if (panel && panel.classList.contains('is-open')) {
          closePanel();
        } else {
          openPanel();
        }
      }
    });

    // Desktop hover on trigger
    trigger.addEventListener('mouseenter', function () {
      if (window.innerWidth > 1024) {
        header.classList.add('is-hovering-menu');
        openPanel();
      }
    });
    trigger.addEventListener('mouseleave', function (e) {
      // wait a tick, then check if mouse moved to panel
      setTimeout(function () {
        if (panel && panel.matches(':hover')) return;
        if (!header.contains(e.relatedTarget) || (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-mega-menu-panel]'))) return;
        header.classList.remove('is-hovering-menu');
        closePanel();
      }, 50);
    });

    // Desktop hover on panel to keep open
    if (panel) {
      panel.addEventListener('mouseenter', function () {
        if (window.innerWidth > 1024) {
          header.classList.add('is-hovering-menu');
          openPanel();
        }
      });
      panel.addEventListener('mouseleave', function () {
        if (window.innerWidth > 1024) {
          header.classList.remove('is-hovering-menu');
          closePanel();
        }
      });
    }

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega-menu-panel]') && !e.target.closest('[data-mega-menu-trigger]')) {
        header.classList.remove('is-hovering-menu');
        closePanel();
      }
    });

    // Close when mouse leaves header area
    header.addEventListener('mouseleave', function (e) {
      if (window.innerWidth <= 1024) return;
      if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-mega-menu-panel]')) return;
      closePanel();
    });
  }

  /* ----- Product gallery & variant image switching ----- */
 function initProductGallery() {
  $$('[data-section-type="product"]').forEach(function (product) {
    var variantSelect = $('.product__variant-select', product);
    var optionInputs = $$('.product__option-input', product);

    var palette = {
      black: '#111', white: '#fff', 'flat white': '#f0ebe1',
      grey: '#888', gray: '#888', navy: '#1a2347', blue: '#1e4d8c',
      green: '#2e5d3a', red: '#b1342d', sand: '#c2b280',
      stone: '#928a7c', brown: '#6b4423', cream: '#f5ead2',
      beige: '#d8c8a8', khaki: '#c3b091', olive: '#6b6b3a',
      charcoal: '#36454f', burgundy: '#722f37'
    };

    $$('.product__option-value--color', product).forEach(function (label) {
      var handle = label.dataset.colorHandle || (label.dataset.value || '').toLowerCase();
      var color = palette[handle];
      if (color) {
        label.style.setProperty('background-color', color, 'important');
        if (['white','cream','beige','flat white'].indexOf(handle) !== -1) {
          label.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.1)';
        }
      }
    });

    function switchImage(mediaId) {
      var galleryItems = $$('.product__gallery-item', product);
      var thumbs = $$('.product__gallery-thumb', product);
      galleryItems.forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId));
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
      });
    }

    // ── 缩略图点击（所有产品都绑定，不依赖 variantSelect）──
   product.addEventListener('click', function(e) {
  if (e.target.closest('[data-gallery-prev]') || e.target.closest('[data-gallery-next]')) return;
  var thumb = e.target.closest('.product__gallery-thumb');
  if (thumb && thumb.dataset.mediaId) {
    switchImage(thumb.dataset.mediaId);
  }
});



        /*
     * 商品变体切换由 sections/product-information.liquid 负责。
     * 这里不要再次绑定 .product__option-input 的 change 事件，
     * 否则两套逻辑会同时修改 variant、价格和图片。
     */

    return;

  });
}



  /* ----- Cart Drawer ----- */
  function initCartDrawer() {
    var drawer = $('#cart-drawer');
    if (!drawer) {
      console.error('Cart drawer not found');
      return;
    }

    var overlay = $('[data-cart-drawer-overlay]', drawer);
    var closeBtn = $('[data-cart-drawer-close]', drawer);
    var cartToggle = $('[data-cart-toggle]');
    var cartCount = $('[data-cart-count]');
    var drawerCount = $('[data-cart-drawer-count]', drawer);
    var drawerSubtotalRow = $('[data-cart-subtotal-row]', drawer);
    var drawerSubtotal = $('[data-cart-subtotal]', drawer);
    var popular = $('[data-cart-popular]', drawer);
    var cartBody = $('[data-cart-body]', drawer);
    var cartFooter = $('[data-cart-footer]', drawer);
    var cartActions = $('[data-cart-actions]', drawer);
    var cartNote = $('[data-cart-note]', drawer);
    var cartUpdating = false;  // Lock to prevent concurrent updates

    console.log('Cart drawer initialized:', {
      drawer: !!drawer,
      cartBody: !!cartBody,
      cartBodyInDOM: cartBody ? !!document.body.contains(cartBody) : false
    });

    function open() {
  drawer.classList.add('is-open');
  document.body.classList.add('cart-drawer-open');
  fetchCart();
}
// 暴露给外部调用
window.__openCartDrawer = open;  // ← 加这一行


    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
    }

    function fetchCart() {
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          updateCartUI(cart);
        })
        .catch(function(err) {
          console.error('Error fetching cart:', err);
        });
    }

    function updateCartUI(cart) {
      if (!cartBody) return;

      var html = '';
      if (cart.items && cart.items.length > 0) {
        html = '<div class="cart-drawer__items">';
        cart.items.forEach(function(item, index) {
          var variantTitle = item.variant_title !== 'Default Title' ? item.variant_title : '';
          var hasDiscount = item.original_line_price > item.final_line_price;
          
          console.log('Item:', item.product_title, 'qty:', item.quantity, 'final_line_price:', item.final_line_price, 'original_line_price:', item.original_line_price);

          html += '<div class="cart-drawer-item" data-key="' + item.key + '">';
          html += '<div class="cart-drawer-item__image">';
          if (item.image) {
            html += '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">';
          }
          html += '</div>';
          html += '<div class="cart-drawer-item__info">';
          
          // Header: Title + Price
          html += '<div class="cart-drawer-item__header">';
          html += '<a href="' + item.url + '" class="cart-drawer-item__title">' + item.product_title + '</a>';
          html += '<span class="cart-drawer-item__total">' + formatMoney(item.final_line_price) + '</span>';
          html += '</div>';
          
          if (variantTitle) {
            html += '<p class="cart-drawer-item__variant">' + variantTitle + '</p>';
          }
          
          html += '<div class="cart-drawer-item__price">';
          if (hasDiscount) {
            html += '<s>' + formatMoney(item.original_price) + '</s> ';
          }
          html += formatMoney(item.final_price) + '</div>';

          if (item.discounts && item.discounts.length > 0) {
            item.discounts.forEach(function(discount) {
              var discountAmount = discount.total_amount || discount.amount || 0;
              if (typeof discountAmount === 'string') {
                discountAmount = parseFloat(discountAmount);
              }
              // Shopify returns amount in cents, so divide by 100 if > 100
              if (discountAmount > 100) {
                discountAmount = discountAmount / 100;
              }
              if (discountAmount) {
                html += '<p class="cart-drawer-item__discount">' + discount.title + ' (-$' + discountAmount.toFixed(2) + ')</p>';
              }
            });
          }
          
          // Bottom: Quantity + Remove
          html += '<div class="cart-drawer-item__bottom">';
          html += '<div class="cart-drawer-item__quantity" data-line="' + (index + 1) + '">';
          html += '<button type="button" class="cart-drawer-item__qty-btn" data-qty-change="minus"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 6h8"/></svg></button>';
          html += '<input type="number" class="cart-drawer-item__qty-input" value="' + item.quantity + '" min="0" data-qty-input data-variant-id="' + item.variant_id + '">';
          html += '<button type="button" class="cart-drawer-item__qty-btn" data-qty-change="plus"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2v8M2 6h8"/></svg></button>';
          html += '</div>';
          html += '<button type="button" class="cart-drawer-item__remove" data-remove-item data-variant-id="' + item.variant_id + '" data-line="' + (index + 1) + '">Remove</button>';
          html += '</div></div></div>';
        });
        html += '</div>';

        if (cartFooter) cartFooter.style.display = '';
        if (cartActions) cartActions.style.display = '';
        if (popular) popular.style.display = '';
        if (drawerSubtotalRow) drawerSubtotalRow.hidden = false;
      } else {
        html = '<div class="cart-drawer__empty">';
        html += '<svg class="cart-drawer__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';
        html += '<p>Your cart is empty.</p>';
        html += '<a href="/collections/all" class="button button--secondary">Explore New Arrivals</a>';
        html += '</div>';

        if (cartFooter) cartFooter.style.display = 'none';
        if (cartActions) cartActions.style.display = 'none';
        if (popular) popular.style.display = 'none';
        if (drawerSubtotalRow) drawerSubtotalRow.hidden = true;
      }

      if (drawerSubtotal && cart.total_price !== undefined) {
        console.log('Updating subtotal:', cart.total_price, '->', formatMoney(cart.total_price));
        drawerSubtotal.textContent = formatMoney(cart.total_price);
      }
      if (drawerCount) {
        drawerCount.textContent = '(' + (cart.item_count || 0) + ')';
      }

      console.log('Updating cartBody.innerHTML, cartBody exists:', !!cartBody, 'items:', cart.items ? cart.items.length : 0);
      console.log('HTML being set:', html.substring(0, 500));
      
      // Only rebuild if cartBody exists
      if (!cartBody) {
        console.log('cartBody not found, skipping update');
        return;
      }
      
      // Simple direct replacement
      cartBody.innerHTML = html;
      
      // Force DOM update
      void cartBody.offsetHeight;
      
      console.log('cartBody.innerHTML updated, new children:', cartBody.children.length);
      
      // No need to re-attach events - using delegation at drawer level
    }

    // Use document-level event delegation for reliability
    document.addEventListener('click', function(e) {
      // Only handle clicks when drawer is open
      if (!drawer.classList.contains('is-open')) return;
      
      var qtyBtn = e.target.closest('.cart-drawer-item__qty-btn');
if (qtyBtn) {
  e.preventDefault();
  e.stopPropagation();
  
  var input = qtyBtn.parentElement.querySelector('[data-qty-input]');
  if (!input) {
    console.log('No input found for qty btn');
    return;
  }
  
  var variantId = input.dataset.variantId;
  var lineEl = qtyBtn.closest('[data-line]');
  var line = lineEl ? lineEl.dataset.line : null;
  var currentQty = parseInt(input.value, 10) || 0;
  var newQty = qtyBtn.dataset.qtyChange === 'plus' ? currentQty + 1 : currentQty - 1;
  if (newQty < 0) newQty = 0;
  
  console.log('Qty btn clicked:', {
    variantId: variantId,
    line: line,
    currentQty: currentQty,
    newQty: newQty,
    btnType: qtyBtn.dataset.qtyChange
  });
  
  document.querySelectorAll('.cart-drawer-item__qty-btn').forEach(function(btn) {
    btn.disabled = true;
  });
  updateCartItem(variantId, newQty, line, function() {
    document.querySelectorAll('.cart-drawer-item__qty-btn').forEach(function(btn) {
      btn.disabled = false;
    });
  });
  return;
}

      
      var removeBtn = e.target.closest('[data-remove-item]');
if (removeBtn) {
  e.preventDefault();
  e.stopPropagation();
  
  var variantId = removeBtn.dataset.variantId;
  var lineEl = removeBtn.closest('[data-line]') || removeBtn.closest('.cart-drawer-item');
  var line = removeBtn.dataset.line || null;
  console.log('Remove btn clicked, variantId:', variantId, 'line:', line);
  
  removeBtn.disabled = true;
  updateCartItem(variantId, 0, line, function() {
    removeBtn.disabled = false;
  });
  return;
}

    });

    // Quantity input change
    document.addEventListener('change', function(e) {
      if (!e.target.matches('.cart-drawer-item__qty-input')) return;
      if (!drawer.classList.contains('is-open')) return;
      
      var input = e.target;
      var variantId = input.dataset.variantId;
      var newQty = parseInt(input.value, 10) || 0;
      if (newQty < 0) newQty = 0;
      updateCartItem(variantId, newQty);
    });

    // Debounce timer for cart updates
    var cartUpdateTimer = null;
    var pendingCartUpdate = null;
    
    function updateCartItem(variantId, quantity, line, onComplete) {
  console.log('>>> updateCartItem called:', { variantId: variantId, quantity: quantity, line: line });
  
  pendingCartUpdate = { variantId: variantId, quantity: quantity, line: line, onComplete: onComplete };
  
  if (cartUpdateTimer) {
    clearTimeout(cartUpdateTimer);
  }
  
  cartUpdateTimer = setTimeout(function() {
    executeCartUpdate(pendingCartUpdate.variantId, pendingCartUpdate.quantity, pendingCartUpdate.line, pendingCartUpdate.onComplete);
    pendingCartUpdate = null;
  }, 300);
}

    
    function executeCartUpdate(variantId, quantity, line, onComplete) {
      // Prevent concurrent updates
      if (cartUpdating) {
        console.log('Cart update in progress, skipping');
        if (onComplete) onComplete();
        return;
      }
      cartUpdating = true;
      
      // Use /cart/change.js which is more reliable
      var params = new URLSearchParams();
if (line) {
  params.append('line', line);
} else {
  params.append('id', variantId);
}
params.append('quantity', quantity);

      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
      })
      .then(function(response) {
        console.log('Update response status:', response.status, response.statusText);
        if (!response.ok) {
          return response.text().then(function(text) {
            console.error('Update error response:', text);
            throw new Error('Cart update failed');
          });
        }
        return response.json();
      })
      .then(function(cart) {
        console.log('>>> Cart updated successfully:', cart.item_count, 'items, total:', cart.total_price);
        updateCartUI(cart);
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function(err) {
        console.error('Error updating cart:', err);
      })
      .finally(function() {
        cartUpdating = false;
        if (onComplete) onComplete();
      });
    }

    function updateCartCount(count) {
      if (cartCount) {
        cartCount.textContent = count;
        if (count > 0) {
          cartCount.classList.remove('hidden');
        } else {
          cartCount.classList.add('hidden');
        }
      }
    }

    // Event listeners
    if (cartToggle) {
      cartToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (drawer.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        close();
      }
    });

    // Intercept checkout link click - fetch latest cart before checkout
    var checkoutLink = document.querySelector('[data-checkout-btn]');
    if (checkoutLink) {
      checkoutLink.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Checkout clicked, fetching latest cart...');
        
        checkoutLink.textContent = 'Loading...';
        checkoutLink.style.pointerEvents = 'none';
        
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            console.log('Latest cart before checkout:', {
              item_count: cart.item_count,
              total_price: cart.total_price,
              items: cart.items
            });
            
            // Update UI with latest data
            updateCartUI(cart);
            
            // Redirect to checkout
            window.location.href = '/checkout';
          })
          .catch(function(err) {
            console.error('Error fetching cart before checkout:', err);
            // Still allow checkout even if fetch fails
            window.location.href = '/checkout';
          });
      });
    }

    // Listen for cart updates and sync header cart count
    document.addEventListener('cart:updated', function(e) {
      var cart = e.detail;
      if (cart && cart.item_count !== undefined) {
        updateHeaderCartCount(cart.item_count);
      }
    });

    function updateHeaderCartCount(count) {
      var headerCount = $('[data-cart-count]');
      if (headerCount) {
        headerCount.textContent = count;
        if (count > 0) {
          headerCount.classList.remove('hidden');
        } else {
          headerCount.classList.add('hidden');
        }
      }
    }

    // Listen for add-to-cart events
    document.addEventListener('product:add-to-cart', function(e) {
      open();
    });

   

// ── Product Add to Cart: unified form flow ──

var productForm = document.querySelector('form.product__form');

if (productForm) {
 function addCurrentProductToCart(event) {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

    var productRoot = productForm.closest(
    '[data-section-type="product"]'
  );

  if (!productRoot) {
    console.error('[PRODUCT CART] Product root not found');
    return;
  }

  var selectedOptions = {};

  productRoot.querySelectorAll('.product__option').forEach(function(optionEl) {
    var index = optionEl.getAttribute('data-option-index');
    var checked = optionEl.querySelector(
      '.product__option-input:checked'
    );

    if (checked) {
      selectedOptions[index] = checked.value;
    }
  });

  var optionCount = productRoot.querySelectorAll(
    '.product__option'
  ).length;

  var selectedOptionCount = Object.keys(
    selectedOptions
  ).length;

  if (selectedOptionCount !== optionCount) {
    console.error(
      '[PRODUCT CART] Not all options selected:',
      selectedOptions
    );
    return;
  }

  var matchedVariant = null;

  productRoot.querySelectorAll(
    '[data-variant-id][data-variant-title]'
  ).forEach(function(variantEl) {
    var title = variantEl.getAttribute(
      'data-variant-title'
    ) || '';

    var parts = title.split(' / ');

    var matches = parts.length === optionCount &&
      Object.keys(selectedOptions).every(function(index) {
        return parts[parseInt(index, 10)] === selectedOptions[index];
      });

    if (matches) {
      matchedVariant = variantEl;
    }
  });

  if (!matchedVariant) {
    console.error(
      '[PRODUCT CART] No matching variant:',
      selectedOptions
    );
    return;
  }

  var variantId = String(
    matchedVariant.getAttribute('data-variant-id') || ''
  ).trim();

  var activeVariantInput = productForm.querySelector(
    '[data-active-variant-id]'
  );

  if (activeVariantInput) {
    activeVariantInput.value = variantId;
  }

  console.log('[PRODUCT CART] submitting variant:', {
    variantId: variantId,
    selectedOptions: selectedOptions,
    variantTitle: matchedVariant.getAttribute(
      'data-variant-title'
    )
  });


    if (!variantId || !/^\d+$/.test(variantId)) {
      console.error(
        '[PRODUCT CART] Invalid variant ID:',
        variantId
      );
      return;
    }

    var buttons = productForm.querySelectorAll(
      '[data-add-to-cart], [data-add-to-cart-mobile]'
    );

    buttons.forEach(function(button) {
      button.disabled = true;

      var textEl =
        button.querySelector('[data-add-to-cart-text]') ||
        button.querySelector('span');

      if (textEl) {
        textEl.textContent = 'Adding...';
      }
    });

   var cartParams = new URLSearchParams();

cartParams.append('id', variantId);
cartParams.append('quantity', '1');

fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json'
  },
  body: cartParams.toString()
})
  .then(function(response) {
    return response.text().then(function(text) {
      var data = {};

      try {
        data = text ? JSON.parse(text) : {};
      } catch (parseError) {
        data = {
          message: text
        };
      }

      if (!response.ok) {
        var message =
          data.description ||
          data.message ||
          data.status ||
          'Cart add request failed';

        throw new Error(message);
      }

      return data;
    });
  })

      .then(function() {
        return fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        });
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        updateHeaderCartCount(cart.item_count);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: cart
        }));

      if (typeof window.__openCartDrawer === 'function') {
  window.__openCartDrawer();
}


        buttons.forEach(function(button) {
          var textEl =
            button.querySelector('[data-add-to-cart-text]') ||
            button.querySelector('span');

          if (textEl) {
            textEl.textContent = 'Added';
          }
        });
      })
     .catch(function(error) {
  console.error(
    '[PRODUCT CART] Add failed:',
    error && error.message
      ? error.message
      : error
  );


        buttons.forEach(function(button) {
          var textEl =
            button.querySelector('[data-add-to-cart-text]') ||
            button.querySelector('span');

          if (textEl) {
            textEl.textContent = 'Error';
          }
        });
      })
      .finally(function() {
        setTimeout(function() {
          buttons.forEach(function(button) {
            button.disabled = false;

            var textEl =
              button.querySelector('[data-add-to-cart-text]') ||
              button.querySelector('span');

            if (textEl) {
              textEl.textContent = 'Add to cart';
            }
          });
        }, 1200);
      });
  }

  // 桌面按钮和表单内移动按钮
  productForm.querySelectorAll(
    '[data-add-to-cart], [data-add-to-cart-mobile]'
  ).forEach(function(button) {
    button.addEventListener(
      'click',
      addCurrentProductToCart
    );
  });

  // sticky mobile button requestSubmit() 会走这里
   productForm.addEventListener(
    'submit',
    addCurrentProductToCart
  );
  } // 结束 if (productForm)
} // 结束 initCartDrawer()








    


  /* ----- Search Modal ----- */
  function initSearchModal() {
    var modal = $('#search-modal');
    if (!modal) return;

    var overlay = $('[data-search-overlay]', modal);
    var closeBtn = $('[data-search-close]', modal);
    var searchToggle = $('[data-search-toggle]');
    var searchInput = $('[data-search-input]', modal);
    var searchBody = $('[data-search-body]', modal);
    var searchResults = $('[data-search-results]', modal);
    var searchEmpty = $('[data-search-empty]', modal);
    var searchLoading = $('[data-search-loading]', modal);
    var searchSuggestions = $('[data-search-suggestions]', modal);

    var searchTimeout = null;

    function open() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (searchInput) searchInput.focus();
      }, 100);
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function performSearch(query) {
      if (!query || query.length < 2) {
        searchResults.innerHTML = '';
        searchEmpty.hidden = true;
        searchSuggestions.hidden = false;
        return;
      }

      searchLoading.hidden = false;
      searchSuggestions.hidden = true;

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6';

      fetch(url)
        .then(function(response) { return response.json(); })
        .then(function(data) {
          searchLoading.hidden = true;
          var products = data.resources.results.products || [];

          if (products.length === 0) {
            searchResults.innerHTML = '';
            searchEmpty.hidden = false;
            return;
          }

          searchEmpty.hidden = true;
          var html = '';
          products.forEach(function(product) {
            var price = product.price ? '$' + (product.price / 100).toFixed(2) : '';
            var comparePrice = product.compare_at_price ? '$' + (product.compare_at_price / 100).toFixed(2) : '';
            var hasDiscount = product.compare_at_price && product.compare_at_price > product.price;

            html += '<a href="' + product.url + '" class="search-modal__result">';
            if (product.image) {
              html += '<div class="search-modal__result-image"><img src="' + product.image + '" alt="' + product.title + '" loading="lazy"></div>';
            }
            html += '<div class="search-modal__result-info">';
            html += '<span class="search-modal__result-title">' + product.title + '</span>';
            html += '<span class="search-modal__result-price">';
            if (hasDiscount) {
              html += '<s>' + comparePrice + '</s> ' + price;
            } else {
              html += price;
            }
            html += '</span>';
            html += '</div></a>';
          });

          searchResults.innerHTML = html;
        })
        .catch(function(err) {
          searchLoading.hidden = true;
          console.error('Search error:', err);
        });
    }

    // Event listeners
    if (searchToggle) {
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (modal.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
      if (e.key === '/' && !modal.classList.contains('is-open') && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
        e.preventDefault();
        open();
      }
    });

    // Search input
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        var query = searchInput.value.trim();
        searchTimeout = setTimeout(function() {
          performSearch(query);
        }, 300);
      });

      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          clearTimeout(searchTimeout);
          var form = searchInput.closest('form');
          if (form) form.submit();
        }
      });
    }
  }

  /* ----- Size Guide Modal ----- */
  function initSizeGuideModal() {
    var modal = $('#size-guide-modal');
    if (!modal) return;

    var overlay = $('[data-size-guide-overlay]', modal);
    var closeBtn = $('[data-size-guide-close]', modal);
    var triggers = $$('[data-size-guide-trigger]');

    function open() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', open);
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });
  }

  /* ----- Product grid carousel ----- */
  function initProductGridCarousel() {
    var sections = $$('section[data-section-type="product-grid"]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var scrollEl = $('[data-product-grid-scroll]', section);
      var prevBtn = $('[data-product-grid-prev]', section);
      var nextBtn = $('[data-product-grid-next]', section);
      if (!scrollEl) return;

      var perView = parseInt(section.dataset.productsPerView, 10) || 5;
      var gap = 24;

      function step() {
        var firstChild = scrollEl.querySelector('[data-product-grid-items] > *');
        var childWidth = firstChild ? firstChild.getBoundingClientRect().width : 0;
        return (childWidth + gap) * perView;
      }

      function maxScroll() {
        return Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
      }

      function updateArrows() {
        var x = scrollEl.scrollLeft;
        var atStart = x <= 1;
        var atEnd = x >= maxScroll() - 1;
        if (prevBtn) prevBtn.disabled = atStart;
        if (nextBtn) nextBtn.disabled = atEnd;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollEl.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollEl.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      scrollEl.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      // Run after layout settles
      setTimeout(updateArrows, 50);
    });
  }

  /* ----- Product description read more ----- */
  function initReadMore() {
    $$('[data-read-more-wrap]').forEach(function (wrap) {
      var content = $('[data-read-more-content]', wrap);
      var btn = $('[data-read-more-toggle]', wrap);
      if (!content || !btn) return;

      var collapsed = true;
      content.classList.add('is-collapsed');
      content.style.maxHeight = '6.5em';
      btn.hidden = false;

      function checkOverflow() {
        if (content.scrollHeight <= content.clientHeight + 1) {
          btn.hidden = true;
          content.classList.remove('is-collapsed');
          content.style.maxHeight = '';
        } else {
          btn.hidden = false;
        }
      }

      checkOverflow();
      window.addEventListener('resize', checkOverflow);

      btn.addEventListener('click', function () {
        collapsed = !collapsed;
        if (collapsed) {
          content.classList.add('is-collapsed');
          content.style.maxHeight = '6.5em';
          btn.textContent = 'Read more';
        } else {
          content.classList.remove('is-collapsed');
          content.style.maxHeight = content.scrollHeight + 'px';
          btn.textContent = 'Read less';
        }
      });
    });
  }

  /* ----- Product detail modal (Product Details / FAQs / Shipping & Returns) ----- */
  function initProductModal() {
    var body = document.body;

    $$('[data-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.modalOpen;
        var modal = $('[data-product-modal="' + target + '"]');
        if (!modal) return;

        modal.removeAttribute('hidden');
        body.classList.add('product-modal-open');
        modal.querySelector('.product-modal__panel').focus();
      });
    });

    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      body.classList.remove('product-modal-open');
    }

    $$('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(btn.closest('.product-modal'));
      });
    });

    $$('[data-modal-backdrop]').forEach(function (backdrop) {
      backdrop.addEventListener('click', function () {
        closeModal(backdrop.closest('.product-modal'));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = $('.product-modal:not([hidden])');
        if (open) closeModal(open);
      }
    });
  }

  /* ----- Mobile sticky Add-to-Cart ----- */
 function initMobileATC() {
  var bar = $('[data-mobile-atc]');
  if (!bar) return;
  document.body.classList.add('has-mobile-atc');

  var trigger = $('[data-add-to-cart-mobile]', bar);
  if (!trigger) return;

  trigger.addEventListener('click', function() {
    // 用更宽泛的 selector 确保找到 form
    var form = document.querySelector('form.product__form')
            || document.querySelector('form[action="/cart/add"]')
            || document.querySelector('[data-product-form] form');
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });
}
function initGalleryArrows() {
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  if (!prevBtn || !nextBtn) return;

  // 克隆替换，清除所有旧监听器
  var newPrev = prevBtn.cloneNode(true);
  var newNext = nextBtn.cloneNode(true);
  prevBtn.parentNode.replaceChild(newPrev, prevBtn);
  nextBtn.parentNode.replaceChild(newNext, nextBtn);

  function getIds() {
    return Array.from(document.querySelectorAll('.product__gallery-item')).map(function(el) {
      return el.dataset.mediaId;
    });
  }

  function getActiveIndex(ids) {
    var active = document.querySelector('.product__gallery-item.is-active');
    return active ? ids.indexOf(active.dataset.mediaId) : 0;
  }

  function switchGalleryImage(mediaId) {
    document.querySelectorAll('.product__gallery-item').forEach(function(item) {
      item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId));
    });
    document.querySelectorAll('.product__gallery-thumb, .product__mobile-thumb').forEach(function(thumb) {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
    });
  }

  newPrev.addEventListener('click', function(e) {
    e.stopPropagation();
    var ids = getIds();
    switchGalleryImage(ids[(getActiveIndex(ids) - 1 + ids.length) % ids.length]);
  });

  newNext.addEventListener('click', function(e) {
    e.stopPropagation();
    var ids = getIds();
    switchGalleryImage(ids[(getActiveIndex(ids) + 1) % ids.length]);
  });
}


  /* ----- Product variant click guard ----- */
  function initProductVariantClickGuard() {
    document.addEventListener('click', function(event) {
      var target = event.target.closest('.product__option-value');

      if (!target) return;

      var productRoot = target.closest(
        '[data-section-type="product"]'
      );

      if (!productRoot) return;

      var inputId = target.getAttribute('for');
      var input = document.getElementById(inputId);

      if (!input || input.disabled) return;

      /*
       * 阻止外部 React onClick 把点击事件序列化到 URL。
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      productRoot.querySelectorAll('.product__option-input').forEach(function(optionInput) {
        if (optionInput.name === input.name) {
          optionInput.checked = false;
        }
      });

     input.checked = true;

// 立即更新 Color 标题旁边的英文名称
var optionEl = input.closest('.product__option');

if (optionEl) {
  var selectedText = optionEl.querySelector(
    '.product__option-selected'
  );

  if (selectedText) {
    selectedText.textContent = input.value;
  }
}

if (typeof window.__lawlessUpdateVariant === 'function') {
  window.__lawlessUpdateVariant();
}

else {
  input.dispatchEvent(new Event('change', {
    bubbles: true
  }));
}

    }, true);
  }

  // 立即注册，不能等到 DOMContentLoaded
  initProductVariantClickGuard();

  /* ----- Init ----- */
  ready(function () {
        
    initCollectionFilter();
    initStickyHeader();
    initMobileMenu();
    initHero();
    initCountdowns();
    initMegaMenu();
    initProductGallery();
    initCartDrawer();
    initSearchModal();
    initSizeGuideModal();
    initProductGridCarousel();
    initProductModal();
    initReadMore();
    initMobileATC();
    
    initGalleryArrows();
  });
  function initCollectionFilter() {
  var filterBtn = document.querySelector('[data-filter-toggle]');
  var panel = document.getElementById('collection-filter-panel');
  var toolbar = document.getElementById('collection-toolbar');
  if (!filterBtn || !panel) return;

  // 读取当前 URL 参数恢复状态
  var params = new URLSearchParams(window.location.search);
  var activeTags = params.get('filter_tags') ? params.get('filter_tags').split(',') : [];
  var activePrice = params.get('filter_price') || '';

  // 恢复 checkbox 状态
  document.querySelectorAll('[data-filter-tag]').forEach(function(cb) {
    cb.checked = activeTags.indexOf(cb.value) !== -1;
  });
  // 恢复 price radio 状态
  document.querySelectorAll('input[name="filter_price"]').forEach(function(r) {
    r.checked = r.value === activePrice;
  });

  // 更新 filter count badge
  function updateFilterCount() {
    var count = activeTags.length + (activePrice ? 1 : 0);
    var badge = document.querySelector('[data-filter-count]');
    if (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
  }
  updateFilterCount();

  // Toggle panel
  filterBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = !panel.hidden;
    panel.hidden = isOpen;
    filterBtn.setAttribute('aria-expanded', !isOpen);

    // 对齐宽度
    if (!isOpen && toolbar) {
      panel.style.width = toolbar.offsetWidth + 'px';
    }
  });

  // 点击外部关闭
  document.addEventListener('click', function(e) {
    if (!panel.hidden && !panel.contains(e.target) && e.target !== filterBtn) {
      panel.hidden = true;
      filterBtn.setAttribute('aria-expanded', 'false');
    }
  });

  // 筛选组折叠/展开
  document.querySelectorAll('[data-filter-group-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = btn.nextElementSibling;
      var isOpen = !body.hidden;
      body.hidden = isOpen;
      btn.classList.toggle('is-collapsed', isOpen);
    });
  });

  // Apply 按钮
  var applyBtn = document.querySelector('[data-filter-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
  var checkedTags = [];
  document.querySelectorAll('[data-filter-tag]:checked').forEach(function(cb) {
    checkedTags.push(cb.value.toLowerCase());
  });

  var cards = document.querySelectorAll('.product-card-wrapper');
  cards.forEach(function(card) {
    if (checkedTags.length === 0) {
      card.style.display = '';
    } else {
      var cardTags = (card.getAttribute('data-tags') || '').split(',');
      var match = checkedTags.some(function(tag) {
        return cardTags.indexOf(tag) !== -1;
      });
      card.style.display = match ? '' : 'none';
    }
  });

  var countEl = document.querySelector('[data-filter-count]');
  if (countEl) {
    if (checkedTags.length > 0) {
      countEl.textContent = checkedTags.length;
      countEl.removeAttribute('hidden');
    } else {
      countEl.setAttribute('hidden', '');
    }
  }

  var panel = document.getElementById('collection-filter-panel');
  if (panel) panel.setAttribute('hidden', '');
});

  }

  // Clear 按钮
  var clearBtn = document.querySelector('[data-filter-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      document.querySelectorAll('[data-filter-tag]').forEach(function(cb) { cb.checked = false; });
      document.querySelectorAll('input[name="filter_price"]').forEach(function(r) { r.checked = r.value === ''; });
      var basePath = window.location.pathname.split('/tagged/')[0];
      window.location.href = basePath;
    });
  }
}
})();



